<template>
    <div>
        <div class="custom-loader-wrapper" v-if="loader">
			<div class="text-center">
				<span class="d-block max-450">
					We are processing your download and this may take some time. Do not close this window until the download begins.
				</span>
				<img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" />
				<p class="mt-5">
					Plesae click
					<a target="_blank" :href="$api_url+'/'">here</a>
					or below if you want to continue surfing the system.
				</p>
				<b-button class="mb-1" target="_blank" :href="$api_url+'/'">
					Dashboard
				</b-button>
			</div>
		</div> 

        <div class="row no-gutters py-2 mt-3 company-form-container-warapper">
            <div class="ibox col-md-12 border-0">
                <div class="ibox-title dashboard_title company-form-box-title">
                    <h4 class="clearfix">
                        <span class="">Provident Fund Contribution Summary
                            <span class="title-sub-text">Get a clear picture of your PF Contribution. Use this information to better understand your workforce.
                            </span>
                        </span> 
                        <span class="float-right">
                            
                        </span>
                    </h4>
                </div>
                <div class="ibox-content pf-summery-data">
                    <div class="row py-3">
                        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 data-block">
                            <div class="summery-block-wrapper">
                            <div class="summery-block-body clearfix">
                            <div class="dash-currency-icon" >&nbsp;&#2547&nbsp;</div> 
                            <div class="dash-widget-info-new">
                            <template v-if ="pf_history_loading">
                                <h3 class="loader-text" > Calculating <img v-bind:src="$api_url+'/images/loading-new-gif.gif'"  class="loader-logo"  /></h3>
                            </template>
                            <template v-else>
                                <h3>{{company_pf_history.available_ff_fund}}</h3>
                            </template>
                            <span>Available Forfeiture Fund</span>
                            </div>
                            </div> 
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 data-block pl-0 mb-2">
                            <div class="summery-block-wrapper">
                            <div class="summery-block-body clearfix">
                            <div class="dash-currency-icon" >&nbsp;&#2547&nbsp;</div>
                            <div class="dash-widget-info-new">
                            <template v-if ="pf_history_loading">
                                <h3 class="loader-text" > Calculating <img v-bind:src="$api_url+'/images/loading-new-gif.gif'"  class="loader-logo"  /></h3>
                            </template>  
                            <template v-else>
                                <h3>{{company_pf_history.company_ff_distributed_amount}}</h3>
                            </template>
                            
                            <span>Total Distributed Forfeiture</span>
                            </div>
                            </div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 data-block pl-0 mb-2">
                            <div class="summery-block-wrapper">
                            <div class="summery-block-body clearfix">
                            <div class="dash-currency-icon" >&nbsp;&#2547&nbsp;</div>
                            <div class="dash-widget-info-new">
                            
                            <template v-if ="pf_history_loading">
                                <h3 class="loader-text" > Calculating <img v-bind:src="$api_url+'/images/loading-new-gif.gif'"  class="loader-logo"  /></h3>
                            </template>
                            <template v-else>
                                <h3>{{company_pf_history.total_distributed_reclaim}}</h3>
                            </template>
                            <span>Total Distributed Forfeiture Reclaim</span>
                            </div>
                            </div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 data-block  mb-2">
                            <div class="summery-block-wrapper">
                            <div class="summery-block-body clearfix"> 
                                <div class="dash-currency-icon" >&nbsp;&#2547&nbsp;</div>
                                <div class="dash-widget-info-new">
                                
                                    <template v-if ="pf_history_loading">
                                        <h3 class="loader-text" > Calculating <img v-bind:src="$api_url+'/images/loading-new-gif.gif'"  class="loader-logo"  /></h3>
                                    </template>
                                    <template v-else>
                                        <h3>{{company_pf_history.total_distributed_profit}}</h3>
                                    </template>
                                    <span>Total Distributed Profit</span>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 data-block  mb-2">
                            <div class="summery-block-wrapper">
                            <div class="summery-block-body clearfix"> 
                                <div class="dash-currency-icon" >&nbsp;&#2547&nbsp;</div>
                                <div class="dash-widget-info-new">
                                
                                    <template v-if ="pf_history_loading">
                                        <h3 class="loader-text" > Calculating <img v-bind:src="$api_url+'/images/loading-new-gif.gif'"  class="loader-logo"  /></h3>
                                    </template>
                                    <template v-else>
                                        <h3>{{company_pf_history.total_waived_profit}}</h3> 
                                    </template>
                                    <span>Total Waived Profit</span>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 data-block pl-0 mb-2">
                            <div class="summery-block-wrapper">
                            <div class="summery-block-body clearfix">
                            <div class="dash-currency-icon" >&nbsp;&#2547&nbsp;</div>
                            <div class="dash-widget-info-new">
                            <template v-if ="pf_history_loading">
                                <h3 class="loader-text" > Calculating <img v-bind:src="$api_url+'/images/loading-new-gif.gif'"  class="loader-logo"  /></h3>
                            </template>
                            <template v-else>
                                <h3>{{company_pf_history.total_distributed_loan}}</h3>
                            </template>
                            
                            <span>Total Distributed Advances</span>
                            </div>
                            </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 data-block pl-0 mb-2">
                            <div class="summery-block-wrapper">
                            <div class="summery-block-body clearfix">
                            <div class="dash-currency-icon" >&nbsp;&#2547&nbsp;</div>
                            <div class="dash-widget-info-new">
                            
                            <template v-if ="pf_history_loading">
                                <h3 class="loader-text" > Calculating <img v-bind:src="$api_url+'/images/loading-new-gif.gif'"  class="loader-logo"  /></h3>
                            </template>
                            <template v-else>
                                <h3>{{company_pf_history.total_refunded_loan}}</h3>
                            </template>
                            <span>Total Refunded Advances</span>
                            </div>
                            </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 data-block  mb-2">
                            <div class="summery-block-wrapper">
                            <div class="summery-block-body clearfix">
                            <div class="dash-currency-icon" >&nbsp;<img v-bind:src="$api_url+'/images/account_circle.png'"  class="account-logo"  />&nbsp;</div>
                            <div class="dash-widget-info-new">
                            
                            <template v-if ="pf_history_loading">
                                <h3 class="loader-text" > Calculating <img v-bind:src="$api_url+'/images/loading-new-gif.gif'"  class="loader-logo"  /></h3>
                            </template>
                            <template v-else>
                                <h3>6</h3>
                            </template>
                            <span>PF Enabled Employees</span>
                            <span class="small-span">as per October 2023</span>
                            </div>
                            </div>
                            </div>
                        </div> 
                        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 data-block pl-0 mb-2 pl-0">
                            <div class="summery-block-wrapper">
                            <div class="summery-block-body clearfix">
                            <div class="dash-currency-icon" >&nbsp;&#2547&nbsp;</div>
                            <div class="dash-widget-info-new">
                            
                            <template v-if ="pf_history_loading">
                                <h3 class="loader-text" > Calculating <img v-bind:src="$api_url+'/images/loading-new-gif.gif'"  class="loader-logo"  /></h3>
                            </template>
                            <template v-else>
                                <h3>{{company_pf_history.total_employee_contribution}}</h3>
                            </template>
                            <span>Employees’ Contribution Till Date</span>
                            </div>
                            </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 data-block pl-0 mb-2">
                            <div class="summery-block-wrapper">
                            <div class="summery-block-body clearfix">
                            <div class="dash-currency-icon" >&nbsp;&#2547&nbsp;</div>
                            <div class="dash-widget-info-new">
                            
                            <template v-if ="pf_history_loading">
                                <h3 class="loader-text" > Calculating <img v-bind:src="$api_url+'/images/loading-new-gif.gif'"  class="loader-logo"  /></h3>
                            </template>
                            <template v-else>
                                <h3>{{company_pf_history.total_employer_contribution}}</h3>
                            </template>
                            <span>Employer’s Contribution Till Date</span>
                            </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        

    </div>
</template>


<script> 
    

    export default{
        mounted() {
           
            
        },
        props: ['readonly','pageurl'],
        
        data(){            
            
            return {
                showoverlay : false,
                cu:window.location.href,
                ce : false,
                company_name:'',
                avatarsrc : null,
                employee_id : 0,
                company_id : 0,
                ewtabIndex : 0,
                employee_exists : 'employee-exists',
                pageUrl : this.$api_url,
                pgeUrl : this.$api_url,
                isHovered: false,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                company_pf_history:[{available_ff_fund:0,company_ff_fund:0}],
                pf_history_loading:true,
                loader:false,
                c_flg: 0, // This variable is for reloading public info

            }
        },
        methods:{
            
            getCompanyPFData: function(){
            let currentObj = this;
            let formData = new FormData();
            axios.post(this.$api_url+'/pf/get-company-pf-data', formData)
              .then(function (response) {
                 this.pf_history_loading = false; 
                 this.company_pf_history = response.data;
                 //this.company_pf_history.available_ff_fund = this.company_pf_history.company_ff_fund - this.company_pf_history.company_ff_distributed_amount - this.company_pf_history.total_distributed_reclaim;
              }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
         
            },
          
            
        },
        created: function(){
            this.getCompanyPFData();
        }

    }

</script>


<style>

.atlhr-pf-wizard  .reports-tab-nav-wrapper .nav-item .nav-link .btn-secondary {
	position: absolute;
	bottom: 10px !important;
}

.atlhr-pf-wizard .reports-tab-nav-wrapper .nav-item .nav-link {
	height: 160px !important;
	position: relative;
}
</style>